import React, { useState, useEffect } from "react";
import axios from "axios";

const AboutSection = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Data
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await axios.get("https://allyoutube-01-02d59d78beb5.herokuapp.com/api/about-section");
        setAboutData(res.data.data);
      } catch (err) {
        console.error("Failed to fetch about data", err);
        setError("Failed to load section.");
      } finally {
        setLoading(false);
      }
    };
    fetchAboutData();
  }, []);

  if (loading) return <div className="text-center py-5"></div>;
  if (error || !aboutData) return null;

  return (
    <>
      <section className="about-section">
        <div className="container">
          <div className="section-wrapper padding-top">
            <div className="row">
              <div className="col-lg-6">
                <div className="about-image">
                  {/* Dynamic Main Image */}
                  <img src={aboutData.mainImage} alt={aboutData.mainTitle} />
                </div>
              </div>
              <div className="col-lg-6 col-md-10">
                <div className="about-wrapper">
                  <div className="section-header">
                    <p>{aboutData.subtitle}</p>
                    <h2>{aboutData.mainTitle}</h2>
                  </div>
                  <div className="about-content">
                    <p>{aboutData.description}</p>
                    
                    {/* Dynamic Features List */}
                    <ul className="about-list">
                      {aboutData.features && aboutData.features.map((feature, index) => (
                        <li key={index} className="about-item d-flex flex-wrap">
                          <div className="about-item-thumb">
                            <img src={feature.icon} alt={feature.title} />
                          </div>
                          <div className="about-item-content">
                            <h5>{feature.title}</h5>
                            <p>{feature.text}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;